<script setup lang="ts">
import DrugInteractionScreen from "@/drug-interaction/views/DrugInteractionScreen.vue";
import {useRoute} from "vue-router";
import ConsumerKeyService from "@/consumer/services/ConsumerKeyService";
import {computed} from "vue";
import BaseContainer from "@/core/components/base/BaseContainer.vue";
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import BaseCardHeader from "@/core/components/base/BaseCardHeader.vue";

const route = useRoute();
const customerId = Number(route.params.customerId);

const key = computed(() => {
    return ConsumerKeyService.consumerKeyFromCustomerId(customerId);
});
</script>

<template>
  <BaseContainer class="p-4">
    <BaseCard>
      <BaseCardHeader>
        Analyse pharmaceutique
      </BaseCardHeader>
      <BaseCardBody>
        <DrugInteractionScreen
          v-if="key"
          :consumer-key="key"
          :customer-id="customerId"
          @track-products="$router.push({
            name: 'customer.products-tracking',
            params: {customerId, consumerKey: key},
          })"
        />
        <p v-else>
          Une erreur est survenue
        </p>
      </BaseCardBody>
    </BaseCard>
  </BaseContainer>
</template>

<style scoped>

</style>
